import { useSelector } from "react-redux";

import LandingSectionBody from "~/components/landings/section/body";
import SectionBody from "~/components/pages/section/body";
import { SiteTypes } from "~/redux/reducers/paramsReducer";

export default function Section({ section }: any) {
  const { siteType } = useSelector((state: any) => state.params);
  return (
    <>
      {siteType === SiteTypes.Baltex && <SectionBody section={section} />}
      {siteType === SiteTypes.Farkop && <SectionBody section={section} />}
      {siteType === SiteTypes.Landing && (
        <LandingSectionBody section={section} />
      )}
    </>
  );
}
